import AllUsersPage from 'pages/User/AllUserPage/AllUsersPage';
import FlaggedUsersPage from 'pages/User/FlaggedUsersPage/FlaggedUsersPage';
import DevicesPage from 'pages/User/DevicesPage/DevicesPage';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainPage from 'pages/core/MainPage/MainPage';
import ProductSuggestionsPage from 'pages/product/ProductSuggestionsPage/ProductSuggestionsPage';
import DeletedProductSuggestionsPage from 'pages/product/DeletedProductSuggestionsPage/DeletedProductSuggestionsPage';
import TeamRequestsPage from 'pages/team/TeamRequestsPage/TeamRequestsPage';
import VerificationCodesPage from 'pages/core/VerificationCodesPage/VerificationCodesPage';
import WhatsappPage from 'pages/core/WhatsappPage/WhatsappPage';
import ActionsPage from 'pages/core/ActionsPage/ActionsPage';
import AllOrdersPage from 'pages/order/AllOrdersPage/AllOrdersPage';
import ProductDetailsPage from 'pages/product/ProductDetailsPage/ProductDetailsPage';
import AllProductsPage from 'pages/product/AllProductsPage/AllProductsPage';
import SearchTestPage from 'pages/product/SearchTestPage/SearchTestPage';
import AgentSearchTestPage from 'pages/product/AgentSearchTestPage/AgentSearchTestPage';
import TaliaChatPage from 'pages/product/TaliaChatPage/TaliaChatPage';
import BeautyProductsPage from 'pages/openFacts/Beauty/BeautyProductsPage';
import CategoriesPage from 'pages/core/CategoriesPage/CategoriesPage';
import RawProductReviewPage from 'pages/rawProduct/RawProductReviewPage/RawProductReviewPage';
import RawProductCategoriesPage from 'pages/rawProduct/RawProductCategoriesPage/RawProductCategoriesPage';
import AllStoresPage from 'pages/store/AllStoresPage/AllStoresPage';
import StoreProductsPage from 'pages/store/StoreProductsPage/StoreProductsPage';
import StoreDetailsPage from 'pages/store/StoreDetailsPage/StoreDetailsPage';
import StoreOrdersPage from 'pages/store/StoreOrdersPage/StoreOrdersPage';
import StoreProductDetailsPage from 'pages/store/StoreProductDetailsPage/StoreProductDetailsPage';
import ContentReportsPage from 'pages/reports/ContentReportsPage/ContentReportsPage';

export default function UserRoutes() {

  return (
    <Routes>
      <Route path="/" element={<MainPage />}>
        <Route path="users/all-users" element={<AllUsersPage />} />
        <Route path="users/flagged" element={<FlaggedUsersPage />} />
        <Route path="users/devices" element={<DevicesPage />} />
        <Route path="teams/team-invitation-requests" element={<TeamRequestsPage />} />
        <Route path="products/suggestions" element={<ProductSuggestionsPage />} />
        <Route path="products/deleted-suggestions" element={<DeletedProductSuggestionsPage />} />
        <Route path="orders/all-orders" element={<AllOrdersPage />} />
        <Route path="actions" element={<ActionsPage />} />
        <Route path="verification-codes" element={<VerificationCodesPage />} />
        <Route path="reports/content" element={<ContentReportsPage />} />
        <Route path="whatsapp" element={<WhatsappPage />} />

        <Route path="products/all-products" element={<AllProductsPage />} />
        <Route path="products/search" element={<SearchTestPage />} />
        <Route path="products/agent-search" element={<AgentSearchTestPage />} />
        <Route path="products/talia" element={<TaliaChatPage />} />
        <Route path="products/all-products/:productId" element={<ProductDetailsPage />} />

        <Route path="categories/all-categories" element={<CategoriesPage />}/>
        <Route path="categories/all-categories/:categoryId" element={<CategoriesPage />}/>
        
        <Route path="raw-products/review" element={<RawProductReviewPage />} />
        <Route path="raw-products/:rawProductId" element={<RawProductReviewPage />} />

        <Route path="raw-products/categories" element={<RawProductCategoriesPage />} />
        <Route path="raw-products/categories/:categoryId" element={<RawProductCategoriesPage />} />

        <Route path="open-facts/beauty" element={<BeautyProductsPage />} />

        <Route path="stores/all-stores" element={<AllStoresPage />} />
        <Route path="stores/store-orders" element={<StoreOrdersPage />} />
        <Route path="stores/all-stores/:storeId" element={<StoreDetailsPage />} />
        <Route path="stores/all-stores/:storeId/store-products/:storeProductId" element={<StoreProductDetailsPage />} />
        <Route path="stores/all-stores/:storeId/products" element={<StoreProductsPage />} />
        <Route path="stores/all-stores/:storeId/products/:categoryId" element={<StoreProductsPage />} />

      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
